var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"149d9ff54635ff064be9c5fdf236f317db3b9ac3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["breeze@otovo"]={id:"149d9ff54635ff064be9c5fdf236f317db3b9ac3"};
      